import React, { Component } from 'react';
import Breadcrumb from '../../Breadcrumb';
import WatchlistNewsComponent from './WatchlistNewsComponent';
import moment from 'moment/moment';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { store } from '../../../redux/store';
import { initialPagePath } from '../../../redux/reducers/PageReducer';
import ComponentName from '../../../constant/ComponentName';
import FolderService from '../../../service/FolderService';
import Icon from '../../../icons/Icon';
import LanguageUtil from '../../../util/LanguageUtil';
import WatchlistExactMatchSwitch from './WatchlistExactMatchSwitch';

class WatchlistNewsLinkComponent extends Component<Props, State> {
  public state: State = new State();

  render() {
    const { date, name, exactMatch } = this.state;
    return (
      <div className='w-full h-full flex flex-col overflow-y-hidden'>
        <Breadcrumb />
        <div className={'p-5'}>
          <div className={'flex justify-between'}>
            <div className={'flex'}>
              <span
                key={'icon'}
                className='w-[60px] h-[60px] min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] mr-1'
              >
                <img src={'/icons/individual.svg'} alt='individual' />
              </span>
              <div className={'flex flex-col justify-center pl-3'}>
                <span className={'text-[24px] 2xl:text-4xl font-normal'}>
                  {name || LanguageUtil.get({ id: 'pages.watchlist.watchlistDetail.news.newsLink.name', defaultMessage: 'News Screening' })}
                </span>
                <div className={'flex items-center gap-x-2'}>
                  <span
                    className={`flex text-xs shrink-0 2xl:text-md h-full justify-center items-center px-[8px] py-[3px] rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                  >
                    {date}
                  </span>
                    <WatchlistExactMatchSwitch value={exactMatch} onChange={this.onExactMatchChange} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'px-5 text-f-black-2 text-[13px] flex items-center gap-x-1'}>
          <Icon icon={'captive_portal'} size={14} color={'#728EFF'} />
          <span>
            {LanguageUtil.get({
              id: 'pages.watchlist.watchlistDetail.news.newsLink.description',
              defaultMessage: 'You can review the news and information on the internet about who meets the search criteria below!',
            })}
          </span>
        </div>
        <WatchlistNewsComponent exactMatch={exactMatch} />
      </div>
    );
  }

  public async componentDidMount() {
    const { router } = this.props;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.WATCHLIST];
    if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST, router.location.pathname, store.getState().page);
    }
    const previousSearchParams = new URLSearchParams(router.params.id);
    let name: string | null = previousSearchParams.get('name');
    this.setState({ name: name, date: moment().format('DD/MM/yyyy HH:mm').valueOf() });
  }

  private onExactMatchChange = (exactMatch: boolean): void => {
    this.setState({ exactMatch });
  };
}

interface Props extends FormicaProps {}

class State {
  date: string | undefined;
  name: string | undefined | null;
  exactMatch: boolean = true;
}

export default withFormica(WatchlistNewsLinkComponent);
